import { render, staticRenderFns } from "./BalanceToaster.vue?vue&type=template&id=2157196e&scoped=true"
import script from "./BalanceToaster.vue?vue&type=script&lang=js"
export * from "./BalanceToaster.vue?vue&type=script&lang=js"
import style0 from "./BalanceToaster.vue?vue&type=style&index=0&id=2157196e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157196e",
  null
  
)

export default component.exports